module.exports = __webpack_public_path__ + "img/provider3.a557b51c.jpg";